import React from "react";
import { AuditLog } from "@common/types/auditLog";
import styles from "./ChatTaskAuditLog.module.scss";

interface Props {
    log: AuditLog;
}

export const ChatTaskAssignee: React.FC<Props> = ({ log }) => {
    const newAssignee =
        log.diff.find((d) => d.field === "assigneeId")?.after?.valueLabel ?? "";
    const oldAssignee =
        log.diff.find((d) => d.field === "assigneeId")?.before?.valueLabel ??
        "";
    if (!newAssignee) {
        return (
            <>
                <span className={styles.chatTaskMessage}>
                    removed&nbsp;<strong>{oldAssignee}</strong>&nbsp;as the
                    assignee from the task
                </span>
            </>
        );
    }
    return (
        <>
            <span className={styles.chatTaskMessage}>
                changed the assignee to&nbsp;<strong>{newAssignee}</strong>
            </span>
        </>
    );
};
